import i18n from '@/plugins/i18n';
import {
  BYTES_TO_MB_CONVERSION_VALUE,
  MS_TO_SECONODS_CONVERSION_VALUE,
} from '@/utils/templates/databaseTemplate/database.constants';

const databaseMSGraphs = {
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('active-connections'),
      header: {
        title: i18n.global.t('active-connections'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#2acbf2'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_active_connections',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.numberOfConnections'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.memory-available'),
      header: {
        title: i18n.global.t('dbm.memory-available'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#98ed78'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_memory_available',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.sizeInMB'),
      },
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.memory-total'),
      header: {
        title: i18n.global.t('dbm.memory-total'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#cc9858'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_memory_total',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.sizeInMB'),
      },
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.memory-utilization'),
      header: {
        title: i18n.global.t('dbm.memory-utilization'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff5bb6'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_memory_utilization',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: '%',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: '%',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.background-processes-count'),
      header: {
        title: i18n.global.t('dbm.background-processes-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#0090ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_background_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('number-of-processes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('number-of-processes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.blocked-processes-count'),
      header: {
        title: i18n.global.t('dbm.blocked-processes-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#5ec5c7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_blocked_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('number-of-processes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('number-of-processes'),
      },
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.diskSize'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#01ce01'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_disk_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.sizeInMB'),
      },
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    /* As per discussion three graphs have been commented out. */
    // {
    //   width: '48%',
    //   title: 'Dormant processes count',
    //   header: {
    //     title: 'Dormant processes count',
    //     titleIcon: '',
    //     content: [],
    //     HideCenterMiscContent: true
    //   },
    //   chartColor: ['#f5fe00'],
    //   height: '12.5em',
    //   entityType: 'ServiceInstance',
    //   independentSelector: false,
    //   metricType: 'REGULAR_VALUE',
    //   metricName: 'meter_instance_dormant_processes_count',
    //   queryMetricType: 'readMetricsValues',
    //   childQueries: [],
    //   chartType: 'ApexChartLine',
    //   unit: '',
    //   axisLabels: {
    //     x: i18n.global.t('dbm.time'),
    //     y: i18n.global.t('number-of-processes')
    //   },
    //   labels: {
    //     xAxis: i18n.global.t('dbm.time'),
    //     yAxis: i18n.global.t('number-of-processes')
    //   }
    // },
    {
      width: '48%',
      title: i18n.global.t('dbm.forced-parameterizations-per-second'),
      header: {
        title: i18n.global.t('dbm.forced-parameterizations-per-second'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#be8ffe'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_forced_parameterizations_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.parameterizations-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.parameterizations-second'),
      },
    },
    // {
    //   width: '48%',
    //   title: 'Preconnect processes count',
    //   header: {
    //     title: 'Preconnect processes count',
    //     titleIcon: '',
    //     content: [],
    //     HideCenterMiscContent: true
    //   },
    //   chartColor: ['#018af2'],
    //   height: '12.5em',
    //   entityType: 'ServiceInstance',
    //   independentSelector: false,
    //   metricType: 'REGULAR_VALUE',
    //   metricName: 'meter_instance_preconnect_processes_count',
    //   queryMetricType: 'readMetricsValues',
    //   childQueries: [],
    //   chartType: 'ApexChartLine',
    //   unit: '',
    //   axisLabels: {
    //     x: i18n.global.t('dbm.time'),
    //     y: i18n.global.t('number-of-processes')
    //   },
    //   labels: {
    //     xAxis: i18n.global.t('dbm.time'),
    //     yAxis: i18n.global.t('number-of-processes')
    //   }
    // },
    {
      width: '48%',
      title: i18n.global.t('dbm.runnable-processes-count'),
      header: {
        title: i18n.global.t('dbm.runnable-processes-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_runnable_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('number-of-processes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('number-of-processes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.runnable-tasks-count'),
      header: {
        title: i18n.global.t('dbm.runnable-tasks-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#98ed78'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_runnable_tasks',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-tasks'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-tasks'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.running-processes-count'),
      header: {
        title: i18n.global.t('dbm.running-processes-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff3d3d'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_running_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('number-of-processes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('number-of-processes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.sleeping-processes-count'),
      header: {
        title: i18n.global.t('dbm.sleeping-processes-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff3d3d'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_sleeping_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('number-of-processes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('number-of-processes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.suspended-processes-count'),
      header: {
        title: i18n.global.t('dbm.suspended-processes-count'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#00c3a5'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_suspended_processes_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('number-of-processes'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('number-of-processes'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.transactions-per-second'),
      header: {
        title: i18n.global.t('dbm.transactions-per-second'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ee2be1'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_instance_transactions_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.transactions-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.transactions-second'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.user-connections'),
      header: {
        title: i18n.global.t('dbm.user-connections'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_stats_connections',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.numberOfConnections'),
      },
    },
    // {
    //   width: '48%',
    //   title: 'Connection kill errors per second',
    //   header: {
    //     title: 'Connection kill errors per second',
    //     titleIcon: '',
    //     content: [],
    //     HideCenterMiscContent: true
    //   },
    //   chartColor: ['#ff5bb6'],
    //   height: '12.5em',
    //   entityType: 'ServiceInstance',
    //   independentSelector: false,
    //   metricType: 'REGULAR_VALUE',
    //   metricName: 'meter_stats_kill_connection_errors_per_second',
    //   queryMetricType: 'readMetricsValues',
    //   childQueries: [],
    //   chartType: 'ApexChartLine',
    //   unit: '',
    //   axisLabels: {
    //     x: i18n.global.t('dbm.time'),
    //     y: '(connection kill errors)/second'
    //   },
    //   labels: {
    //     xAxis: i18n.global.t('dbm.time'),
    //     yAxis: '(connection kill errors)/second'
    //   }
    // },
    {
      width: '48%',
      title: i18n.global.t('dbm.deadlocks-per-second'),
      header: {
        title: i18n.global.t('dbm.deadlocks-per-second'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff8022'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_stats_deadlocks_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.deadlocks-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.deadlocks-second'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.lock-waits-per-second'),
      header: {
        title: i18n.global.t('dbm.lock-waits-per-second'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#98ed78'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_stats_lock_waits_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.lock-waits-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.lock-waits-second'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.sql-compilations-per-second'),
      header: {
        title: i18n.global.t('dbm.sql-compilations-per-second'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#cc9858'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_stats_sql_compilations_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.compilations-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.compilations-second'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.sql-recompilations-per-second'),
      header: {
        title: i18n.global.t('dbm.sql-recompilations-per-second'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff5bb6'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_stats_sql_recompilations_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.re-compilations-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.re-compilations-second'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.user-errors-per-second'),
      header: {
        title: i18n.global.t('dbm.user-errors-per-second'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#0090ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_stats_user_errors_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'errors/second',
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: 'errors/second',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.bufferpool-batch-requests-per-second'),
      header: {
        title: i18n.global.t('dbm.bufferpool-batch-requests-per-second'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#5ec5c7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_bufferpool_batch_requests_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.requests-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.requests-second'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.bufferpool-page-life-expectancy-in-seconds'),
      header: {
        title: i18n.global.t('dbm.bufferpool-page-life-expectancy-in-seconds'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#01ce01'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_bufferpool_page_life_expectancy_in_milliseconds',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.seconds'),
      },
      aggregation: '/',
      aggregationNum: MS_TO_SECONODS_CONVERSION_VALUE,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.bufferPoolSize'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#be8ffe'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_bufferpool_size_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mb'),
      },
      aggregation: '/',
      aggregationNum: BYTES_TO_MB_CONVERSION_VALUE,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.system-buffer-pool-hit-percent'),
      header: {
        title: i18n.global.t('dbm.system-buffer-pool-hit-percent'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff3d3d'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_system_buffer_pool_hit_percent',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.hits-perct'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.hits-perct'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.system-wait-time-in-milliseconds-per-seconds'),
      header: {
        title: i18n.global.t(
          'dbm.system-wait-time-in-milliseconds-per-seconds',
        ),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#5ec5c7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_system_wait_time_in_milliseconds_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.ms-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.ms-second'),
      },
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.buffer-checkpoint-pages-per-seconds'),
      header: {
        title: i18n.global.t('dbm.buffer-checkpoint-pages-per-seconds'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#82c968'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_buffer_checkpoint_pages_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.pages-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.pages-second'),
      },
    },
    {
      width: '97.7%',
      title: i18n.global.t('dbm.average-page-splits-per-seconds'),
      header: {
        title: i18n.global.t('dbm.average-page-splits-per-seconds'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ee2be1'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_access_page_splits_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.page-splits-second'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.page-splits-second'),
      },
    },
  ],
};
export default databaseMSGraphs;
